import { render, staticRenderFns } from "./BundleReviewForm.vue?vue&type=template&id=a5f0a5a8"
import script from "./BundleReviewForm.vue?vue&type=script&lang=js"
export * from "./BundleReviewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports